import { createSelector } from 'reselect';

import {
    mapArrayNumberToStringValues,
    removeAllHTMLAndUnicodeSymbols,
    mapArrayNumberToStringSlug
} from '../../../helpers/helpers';
import moment from 'moment';
import { PostReduxType, PostSelectorType } from '../types';
import { isAuthorNull } from '../../../helpers/isAuthorNull.helpers';
import { InitdataState } from 'store/ducks/app/types';

const categories = (state: { initdata: InitdataState }) =>
    state.initdata.categories;

const tags = (state: { initdata: { tags: InitdataState } }) =>
    state.initdata.tags;

const post = (state: { post: { post: PostReduxType } }) => state.post.post;

export const postSelector = createSelector(
    [post, categories, tags],
    (post, categories, tags) => {
        let renderPost: PostSelectorType = null;
        if (
            post &&
            Object.keys(post).length &&
            Object.keys(categories).length &&
            Object.keys(tags).length
        ) {
            let type = 'post',
                object = {
                    id: post.id,
                    date: moment(post.date).format('DD.MM.YYYY'),
                    categories: mapArrayNumberToStringValues(
                        post.categories,
                        categories
                    ),
                    categoriesEn: mapArrayNumberToStringSlug(
                        post.categories,
                        categories
                    ),
                    description: post.description,
                    title: post.additional.htmlTitle || post.title.rendered,
                    image: post.images.extra,
                    tag: mapArrayNumberToStringValues(post.tags, tags),
                    type: post.type || type,
                    slug: post.slug,
                    content: post.content.rendered,
                    og: post.og,
                    cover: {
                        author: isAuthorNull(post.cover.author),
                    },
                    lead: post.additional.lead,
                    textAuthor: post.additional.textAuthor,
                    photoAuthor: post.additional.photoAuthor,
                };

            renderPost = { ...object };
        }
        return { post: renderPost };
    }
);
